export default __webpack_public_path__ + "static/media/Disney plus clone.3f665cc7.webp";